import { saveAs } from "file-saver";
import api from "./config.url";
import showPopup from "../components/PopUp";
import { setDownloadLoading } from "./downloadLoading";

// Valida os dados obrigatórios do cliente antes de qualquer download.
// Sobrenome é opcional (usa se existir); só nome e CPF são exigidos.
function validateUserForDownload(user) {
  const { name, document: documentCustomer } = user || {};
  if (!name) {
    showPopup(
      "O campo Nome é obrigatório! Acesse seu perfil para preenchê-lo.",
      "error"
    );
    return false;
  }
  if (!documentCustomer) {
    showPopup(
      "O campo CPF é obrigatório! Acesse seu perfil para preenchê-lo.",
      "error"
    );
    return false;
  }
  return true;
}

async function fetchAndSave(sku, user) {
  const customerName = [user.name, user.secondName]
    .filter(Boolean)
    .join(" ");
  const response = await api.post(`/customers/products/cloud-pdf`, {
    sku,
    customerName,
    customerCPF: user.document,
  });
  const pdfUrl = response.data.downloadUrl;
  const fileResponse = await fetch(pdfUrl);
  if (!fileResponse.ok) {
    throw new Error("Erro ao baixar o arquivo");
  }
  const blob = await fileResponse.blob();
  saveAs(blob, `${response.data.fileName}.pdf`);
}

// Download de um único produto (usado no botão de cada caderno).
export async function downloadProductPdf(obj, user, setLoading) {
  if (!validateUserForDownload(user)) return;
  const sku = obj?.sku || obj?.parent?.sku;
  try {
    setDownloadLoading(true);
    await fetchAndSave(sku, user);
  } catch (error) {
    const BackendError = error?.response?.data?.message;
    showPopup(BackendError || "Erro ao baixar os arquivos", "error");
  } finally {
    setDownloadLoading(false);
  }
}

// Download de uma MATÉRIA (parent null):
// - se tiver subcadernos, faz UMA chamada ao endpoint que devolve tudo
//   num único .zip;
// - se não tiver, baixa a própria matéria (PDF simples, sem zip).
// `preloadedChildren` evita um fetch quando os filhos já estão em mãos
// (ex.: "Meus Cadernos" e detalhe do produto). Sem isso, busca pelo slug.
export async function downloadMateria(
  materia,
  user,
  setLoading,
  preloadedChildren
) {
  if (!validateUserForDownload(user)) return;
  try {
    setDownloadLoading(true);

    let children = preloadedChildren || materia?.items;
    if (!children && materia?.slug) {
      try {
        const res = await api.get(
          `/customers/products?current=1&pageSize=200&parent=${materia.slug}`
        );
        children = res.data.records || [];
      } catch (e) {
        children = [];
      }
    }

    const materiaSku = materia?.sku || materia?.parent?.sku;

    // Com subcadernos: uma chamada só → .zip com todos os PDFs.
    if (children && children.length > 0) {
      try {
        const response = await api.post(
          `/customers/products/cloud-pdf-zip`,
          { sku: materiaSku },
          { responseType: "blob" }
        );
        saveAs(response.data, `${materia?.name || "materia"}.zip`);
      } catch (error) {
        // resposta de erro vem como blob quando responseType é blob
        let msg = "Não foi possível baixar os cadernos desta matéria.";
        try {
          const text = await error?.response?.data?.text?.();
          if (text) msg = JSON.parse(text).message || msg;
        } catch (e) {
          /* mantém msg padrão */
        }
        showPopup(msg, "error");
      }
      return;
    }

    // Sem subcadernos: baixa a própria matéria (PDF simples).
    await fetchAndSave(materiaSku, user);
  } catch (error) {
    const BackendError = error?.response?.data?.message;
    showPopup(BackendError || "Erro ao baixar os arquivos", "error");
  } finally {
    setDownloadLoading(false);
  }
}
